<template>
  <div class='slide slide--quiz'>
    <div class='slide_label body-four-light'>
      {{ label }}
    </div>

    <h2 class='slide_headline h-two-light'>
      {{ activity.headline }}
    </h2>

    <div
      v-if='activity.instructions'
      class='slide_subheadline body-one-light'
    >
      {{ activity.instructions }}
    </div>

    <button
      class='slide_cta button-one-light'
      @click.prevent='take()'
    >
      {{ cta }}
    </button>
  </div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  methods: {
    take() {
      this.toggleActivityOverlay()

      if (typeof (dataLayer) !== 'undefined') {
        let category = 'quiz'
        let event_type = 'startQuiz'

        if (this.activity.type === 'activity_v1_self_assessments') {
          category = 'self-assessment'
          event_type = 'startAssessment'
        }

        const event = {
          event: event_type,
          pageCategory: category
        }

        dataLayer.push(event)
      }
    }

  },

  computed: {
    label() {
      if (this.activity.label) {
        return this.activity.label
      } else if (this.activity.type === 'activity_v1_quizzes') {
        return this.$t('quiz')
      } else { // 'activity_v1_self_assessments'
        return this.$t('self_assessment')
      }
    },

    cta() {
      if (this.activity.type === 'activity_v1_quizzes') {
        return this.$t('take_quiz')
      } else { // 'activity_v1_self_assessments'
        return this.$t('take_self_assessment')
      }
    }
  }
}
</script>

<style lang='sass' scoped>
@import './quiz-v1'
</style>
